import { useEffect, useRef } from "react";

export default function useEffectOnce(effect) {
  const hasRun = useRef(false);

  useEffect(() => {
    // console.log(hasRun.current, 'called once');
    
    if (hasRun.current) return;

    hasRun.current = true;
    effect();
  }, []);
}